import React from 'react';
import { Tabs } from '@metarouter-private/mr-mui';
import InputEventTab from './InputEventTab';
import PipelineOutputTab from './PipelineOutputTab';
import { useTestPipelineDrawerContext } from 'app/pipeline-details/StatusItem/TestPipelineDrawerContextProvider';
import IntegrationOutputTab from './IntegrationOutputTab';
import ServerResponseTab from './ServerResponseTab';

export default function TestPipelineDrawerTabsSection() {
  const {
    state: { chainState },
  } = useTestPipelineDrawerContext();
  return (
    <Tabs
      value={chainState.selectedTab}
      onChange={chainState.onSelectTab}
      tabs={[
        {
          label: 'Test Event',
          content: <InputEventTab />,
        },
        {
          label: 'Pipeline Output',
          content: <PipelineOutputTab />,
          TabProps: {
            disabled: chainState.pipelineOutputDisabled,
            disabledTooltip: chainState.pipelineOutputDisabledTooltip,
            onClick: chainState.executePipelineTransform,
          },
        },
        {
          label: 'Integration Output',
          content: <IntegrationOutputTab />,
          TabProps: {
            disabled: chainState.integrationOutputDisabled,
            disabledTooltip: chainState.integrationOutputDisabledTooltip,
            onClick: chainState.executeIntegrationTransform,
          },
        },
        {
          label: 'Server Response',
          content: <ServerResponseTab />,
          TabProps: {
            disabled: chainState.serverResponseDisabled,
            disabledTooltip: chainState.serverResponseDisabledTooltip,
          },
        },
      ]}
    />
  );
}
